import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Text } from '@chakra-ui/react';
import { slide as Menu } from 'react-burger-menu';
import { useTranslation } from 'react-i18next';
import './Burger.css';

export default (props: any) => {
  const { t, i18n } = useTranslation();
  return (
    <Menu right width={'228px'}>
      <NavLink exact to='/about' key={'0'}>
        <Text mr='32px' _hover={{ fontWeight: 600 }}>{t('navbar.about')}</Text>
      </NavLink>
      <br />
      <NavLink exact to='/upload' key={'1'}>
        <Text mr='32px' _hover={{ fontWeight: 600 }}>{t('navbar.verification')}</Text>
      </NavLink>
      <br />
      {i18n.language === 'zh' &&
      <NavLink exact to='/news' key={'2'}>
        <Text mr='32px' _hover={{ fontWeight: 600 }}>{t('navbar.news')}</Text>
      </NavLink>
      }
      {i18n.language === 'zh' &&
      <br />
      }
      <Text fontSize='20px' mr='32px'>{t('navbar.FAQ')}</Text>
      <NavLink exact to='/FAQ1' key={'3'}>
        <Text fontSize='14px' mr='32px' _hover={{ fontWeight: 600 }}>{t('certCategory.degreeCertificate')}</Text>
      </NavLink>
      <NavLink exact to='/FAQ2' key={'4'}>
        <Text fontSize='14px' mr='32px' _hover={{ fontWeight: 600 }}>{t('certCategory.teacherCertificate')}</Text>
      </NavLink>
      <NavLink exact to='/FAQ3' key={'5'}>
        <Text fontSize='14px' mr='32px' _hover={{ fontWeight: 600 }}>{t('certCategory.langCertificate')}</Text>
      </NavLink>
      <NavLink exact to='/FAQ4' key={'6'}>
        <Text fontSize='14px' mr='32px' _hover={{ fontWeight: 600 }}>{t('certCategory.creditCertificate')}</Text>
      </NavLink>
      <NavLink exact to='/FAQ5' key={'7'}>
        <Text fontSize='14px' mr='32px' _hover={{ fontWeight: 600 }}>{t('certCategory.professionalCertificate')}</Text>
      </NavLink>
      <br />
      <NavLink exact to='/school' key={'8'}>
        <Text mr='32px' _hover={{ fontWeight: 600 }}>{t('navbar.issuanceUnits')}</Text>
      </NavLink>
    </Menu>
  );
};
